import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasCategoryContext;

export interface SunSourceProductDetailsProductTypeStyles {
    container?: GridContainerProps;
    categoryGridItem?: GridItemProps;
}

export const sunSourceProductDetailsProductTypeStyles: SunSourceProductDetailsProductTypeStyles = {
    container: {
        gap: 0,
        offsetCss: css`
            max-width: 100%;
        `,
    },
    categoryGridItem: {
        width: 12,
        css: css`
        >${TypographyStyle}{
            &:last-child{
                font-weight: bold;
            }
            font-size: 16px;
            color: #A6A6A6;
        }
        `
    },
};

const styles = sunSourceProductDetailsProductTypeStyles;

const SunSourceProductDetailsProductType = ({ category }: Props) => {
    if (!category) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.categoryGridItem}>
                <Typography>{translate("Product Type:")}&nbsp;</Typography>
                <Typography>{category.name}</Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(SunSourceProductDetailsProductType),
    definition: {
        displayName: "Product Details Product Type",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
